import React from 'react';
import { useParams } from 'react-router-dom';

import OrgTutorsPageShell from './OrgTutorsPageShell';

const PublicOrgPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const resolution = id ? { organizationId: id } : null;

  return <OrgTutorsPageShell resolution={resolution} />;
};

export default PublicOrgPage;
